import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Modal, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { CloseModalIcon } from "../../../../common/components/assets/commonassets/CommonAssets";
import CommonBackDrop from "../../../../common/components/CommonBackDrop/CommonBackDrop";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import CommonDivider from "../../../../common/components/divider/CommonDivider";
import InputArea from "../../../../common/components/FormFields/InputArea";
import { ModalStyle } from "../../../../common/components/modalstyle/ModalStyle";
import CheckBoxField from "../../../../common/components/FormFields/CheckBoxField";
import { RiDownload2Fill } from "react-icons/ri";
import {
  acceptHandoverSummary,
  getHandoverEmp,
  getHandoverSummaryDetails,
  getHandoverSummaryDetailsMorning,
  getHandoverSummaryFullData,
  saveHandoverSummary,
} from "./HandoverSummaryServices";
import {
  errorAlert,
  successAlert,
} from "../../../../common/components/Toasts/CustomToasts";
import InputField from "../../../../common/components/FormFields/InputField";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";
import { ViewIconISBAR } from "../../../../assets/CommonAssets";
import { UseCheckConsecutiveCharacters } from "../../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import ISBARHandoverListingModal from "./ISBARHandoverListingModal";
import ISBARHandoverPasscodeModal from "./ISBARHandoverPasscodeModal";

const ISBARHandover = ({
  complaintModalOpen,
  setComplaintModalOpen,
  // setSelectedRow,
  populateTable,
  setOpenBackdrop,
  openBackDrop,
  displayInfo,
  // = {
  //   AdmissionId: 1071122,
  //   "Patient Name": "Sameer Patil",
  //   MRNo: "MR2026001",
  //   AgeYear: 45,
  //   DoctorName: "Dr.Smith",
  //   "Bed No": "B-12",
  // },
}) => {
  const defaultValues = {
    // Events In Last 24 Hours
    "Events In Last 24 Hoursmorning1": "",
    "Events In Last 24 Hoursevening1": "",
    "Events In Last 24 Hoursnight1": "",

    // Current Issues
    "Current Issuesmorning2": "",
    "Current Issuesevening2": "",
    "Current Issuesnight2": "",

    // Investigation To Be Done
    "Investigation To Be Donemorning3": "",
    "Investigation To Be Doneevening3": "",
    "Investigation To Be Donenight3": "",

    // Investigation Reports Awaited
    "Investigation Reports Awaitedmorning77": "",
    "Investigation Reports Awaitedevening77": "",
    "Investigation Reports Awaitednight77": "",

    // Tasks For Next Shift
    "Tasks For Next Shiftmorning4": "",
    "Tasks For Next Shiftevening4": "",
    "Tasks For Next Shiftnight4": "",

    // Risk Alerts - Morning
    lineM5: false,
    drainsM5: false,
    isolationM5: false,
    fallRiskM5: false,
    remarkM: "",

    // Risk Alerts - Evening
    lineE5: false,
    drainsE5: false,
    isolationE5: false,
    fallRiskE5: false,
    remarkE: "",

    // Risk Alerts - Night
    lineN5: false,
    drainsN5: false,
    isolationN5: false,
    fallRiskN5: false,
    remarkN: "",

    Template: "",
    status: true,
  };
  let userId = JSON.parse(localStorage?.getItem("userInfo"))?.userId;
  const getUserInfo = JSON.parse(localStorage?.getItem("userInfo"));

  const [openPostModal, setOpenPostModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [finalData, setFinalData] = useState([]);
  const [selectedShift, setSelectedShift] = useState("morning");
  const [handoverResultArray, setHandoverResultArray] = useState([]);
  const [passcodeModal, setPasscodeModal] = useState(false);
  const [pendingAcceptShift, setPendingAcceptShift] = useState(null);
  const [employeeNameOptions, setEmployeeNameOptions] = useState([]);
  const [handoverSummaryListingModal, setHandoverSummaryListingModal] =
    useState(false);
  const [empData, setEmpData] = useState([]);
  //   const [accepted, setAccepted] = useState({
  //     morning: false,
  //     evening: false,
  //     night: false,
  //   });
  const handoverSummaryData = [
    // { text: "Overnight Events", id: 1 },
    { text: "Events In Last 24 Hours", id: 1 },
    { text: "Current Issues", id: 2 },
    // { text: "Pending Results", id: 3 },
    { text: "Investigation To Be Done", id: 3 },
    { text: "Investigation Reports Awaited", id: 77 },
    { text: "Tasks For Next Shift", id: 4 },
    { text: "Risk Alerts", id: 5 },
  ];

  const schema = yup.object().shape({});
  const {
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema) });

  // const onSubmit = (data) => {
  //   console.log(data);
  // };

  const onSubmit = (data) => {
    const shiftKey = selectedShift.charAt(0).toUpperCase();
    const isShiftEmpty =
      !data[`Events In Last 24 Hours${selectedShift}1`] &&
      !data[`Current Issues${selectedShift}2`] &&
      !data[`Investigation To Be Done${selectedShift}3`] &&
      !data[`Investigation Reports Awaited${selectedShift}77`] &&
      !data[`Tasks For Next Shift${selectedShift}4`] &&
      !data[`line${shiftKey}5`] &&
      !data[`drains${shiftKey}5`] &&
      !data[`isolation${shiftKey}5`] &&
      !data[`fallRisk${shiftKey}5`] &&
      !data[`remark${shiftKey}`];

    if (isShiftEmpty) {
      errorAlert(
        `Please fill at least one field for ${selectedShift?.charAt(0).toUpperCase() + selectedShift?.slice(1)} shift before saving.`,
      );
      return;
    }
    const handOverToMap = {
      M: data?.assignStaff,
      E: data?.assignStaffEvening,
      N: data?.assignStaffNight,
    };

    const selectedEmployee = handOverToMap[shiftKey];
    if (!selectedEmployee?.id) {
      errorAlert("Please Select Hondover To Name");
      return;
    }

    const formData = {
      eventsIn24hours: data[`Events In Last 24 Hours${selectedShift}1`] || "",
      currentIssues: data[`Current Issues${selectedShift}2`] || "",
      investigationsToBeDone:
        data[`Investigation To Be Done${selectedShift}3`] || "",
      investigationsReportsAwaited:
        data[`Investigation Reports Awaited${selectedShift}77`] || "",
      taskForNextShift: data[`Tasks For Next Shift${selectedShift}4`] || "",
      riskAlerts: [
        data[`line${selectedShift.charAt(0).toUpperCase()}5`] ? "Lines" : null,
        data[`drains${selectedShift.charAt(0).toUpperCase()}5`]
          ? "Drains"
          : null,
        data[`isolation${selectedShift.charAt(0).toUpperCase()}5`]
          ? "Isolation"
          : null,
        data[`fallRisk${selectedShift.charAt(0).toUpperCase()}5`]
          ? "Fall Risk"
          : null,
      ]
        .filter(Boolean)
        .join(", "),
      riskRemarks: data[`remark${selectedShift.charAt(0).toUpperCase()}`] || "",
      handOverBy: getUserInfo?.userId,
      admissionId: displayInfo?.AdmissionId,
      shift: selectedShift.charAt(0).toUpperCase(),
      handoverTo: selectedEmployee?.id || null,
    };

    setFinalData(formData);
    setOpenPostModal(true);
  };

  const fetchAndPatchColumn = async (shift) => {
    try {
      setOpenBackdrop(true);

      const response = await getHandoverSummaryDetails(
        displayInfo?.AdmissionId,
        userId,
        // getUserInfo?.userId,
      );
      const res = response?.data;

      if (res.statusCode === 200) {
        const result = res?.result;
        const shiftKey = shift?.charAt(0)?.toUpperCase();
        handoverSummaryData.forEach((obj) => {
          // if (obj.id !== 5) {
          // Map API fields to form fields by id
          let value = "";

          if (obj.id === 1) value = result?.OverNightEvents || "";
          if (obj.id === 2) value = result?.CurrentIssues || "";
          if (obj.id === 3) value = result?.PlanToBeDone || "";
          if (obj.id === 77) value = result?.ReportsAwaited || "";
          if (obj.id === 4) value = result?.TaskForNextShift || "";

          setValue(`${obj?.text}${shift}${obj?.id}`, value);

          // } else {
          //   // Risk Alerts — no data from API yet, set defaults
          //   setValue(`line${shiftKey}${obj.id}`, false);
          //   setValue(`drains${shiftKey}${obj.id}`, false);
          //   setValue(`isolation${shiftKey}${obj.id}`, false);
          //   setValue(`fallRisk${shiftKey}${obj.id}`, false);
          //   setValue(`remark${shiftKey}`, "");
          // }
        });
      }
    } catch (error) {
      setOpenBackdrop(false);
      console.error("Failed to fetch handover data:", error);
    } finally {
      setOpenBackdrop(false);
    }
  };

  const fetchAndPatchColumnMorning = async (shift) => {
    try {
      setOpenBackdrop(true);

      const response = await getHandoverSummaryDetailsMorning(
        displayInfo?.AdmissionId,
        userId,
        // getUserInfo?.userId,
      );
      const res = response?.data;

      if (res.statusCode === 200) {
        const result = res?.result;
        const shiftKey = shift?.charAt(0)?.toUpperCase();
        handoverSummaryData.forEach((obj) => {
          // if (obj.id !== 5) {
          // Map API fields to form fields by id
          let value = "";

          if (obj.id === 1) value = result?.OverNightEvents || "";
          if (obj.id === 2) value = result?.CurrentIssues || "";
          if (obj.id === 3) value = result?.PlanToBeDone || "";
          if (obj.id === 77) value = result?.ReportsAwaited || "";
          if (obj.id === 4) value = result?.TaskForNextShift || "";

          setValue(`${obj?.text}${shift}${obj?.id}`, value);

          // } else {
          //   // Risk Alerts — no data from API yet, set defaults
          //   setValue(`line${shiftKey}${obj.id}`, false);
          //   setValue(`drains${shiftKey}${obj.id}`, false);
          //   setValue(`isolation${shiftKey}${obj.id}`, false);
          //   setValue(`fallRisk${shiftKey}${obj.id}`, false);
          //   setValue(`remark${shiftKey}`, "");
          // }
        });
      }
    } catch (error) {
      setOpenBackdrop(false);
      console.error("Failed to fetch handover data:", error);
    } finally {
      setOpenBackdrop(false);
    }
  };

  const fetchHandoverMainData = async () => {
    if (displayInfo?.AdmissionId) {
      setHandoverResultArray([]);

      reset({ ...defaultValues });
      try {
        setOpenBackdrop(true);
        let obj = {
          admissionId: selectedRow?.admissionId ?? displayInfo?.AdmissionId,
          date: selectedRow?.EntryDate ?? null,
        };
        const response = await getHandoverSummaryFullData(obj);
        const res = response.data;

        if (res.statusCode === 200) {
          const resultArray = res?.result;
          setHandoverResultArray(resultArray);

          ["morning", "evening", "night"].forEach((shift) => {
            const shiftKey = shift.charAt(0).toUpperCase();
            const result = resultArray?.find(
              (item) => item?.shift === shiftKey,
            );

            if (!result) return;

            setValue(
              `Events In Last 24 Hours${shift}1`,
              result?.eventsIn24hours || "",
            );
            setValue(`Current Issues${shift}2`, result?.currentIssues || "");
            setValue(
              `Investigation To Be Done${shift}3`,
              result?.investigationsToBeDone || "",
            );
            setValue(
              `Investigation Reports Awaited${shift}77`,
              result?.investigationsReportsAwaited || "",
            );
            setValue(
              `Tasks For Next Shift${shift}4`,
              result?.taskForNextShift || "",
            );

            // Parse riskAlerts string into array
            const risks = result?.riskAlerts
              ? result.riskAlerts.split(",").map((r) => r.trim())
              : [];

            // Patch Risk Alerts checkboxes
            setValue(`line${shiftKey}5`, risks.includes("Lines"));
            setValue(`drains${shiftKey}5`, risks.includes("Drains"));
            setValue(`isolation${shiftKey}5`, risks.includes("Isolation"));
            setValue(`fallRisk${shiftKey}5`, risks.includes("Fall Risk"));
            setValue(`remark${shiftKey}`, result?.riskRemarks || "");
          });
        }
      } catch (error) {
        console.error("Failed to fetch handover summary:", error);
      } finally {
        setOpenBackdrop(false);
      }
    }
  };
  useEffect(() => {
    fetchHandoverMainData();
  }, [selectedRow]);
  const handleSaveRecord = () => {
    saveHandoverSummary(finalData)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 409) {
          errorAlert("This record already exists.");
        } else if (res.statusCode === 200 || res.statusCode === 201) {
          //   setComplaintModalOpen(false);
          // populateTable();
          //   setSelectedRow(null);
          successAlert(res.message);
          fetchHandoverMainData();
          setOpenPostModal(false);

          //   reset(defaultValues);
          setOpenBackdrop(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
        // setComplaintModalOpen(false);
        errorAlert(error.message);
        setOpenBackdrop(false);
      });
  };
  const handleAccept = async (shift, shiftKey, passcode) => {
    try {
      setOpenBackdrop(true);

      const shiftData = handoverResultArray?.find(
        (item) => item?.shift === shiftKey,
      );

      const payload = {
        admissionId: displayInfo?.AdmissionId,
        id: shiftData?.id,
        userId: shiftData?.handoverToId,
        passcode,
      };

      const response = await acceptHandoverSummary(payload);
      const res = response?.data;

      if (res.statusCode === 200 || res.statusCode === 201) {
        successAlert(res.message);
        fetchHandoverMainData();
        handlePasscodeClose();
        // setAccepted({ ...accepted, [shift]: true });
      } else {
        errorAlert(res?.message);
      }
    } catch (error) {
      console.error("Failed to accept handover:", error);
      errorAlert(error.message);
    } finally {
      setOpenBackdrop(false);
    }
  };

  const morningData = handoverResultArray?.find((item) => item?.shift === "M");

  const eveningData = handoverResultArray?.find((item) => item?.shift === "E");

  const nightData = handoverResultArray?.find((item) => item?.shift === "N");

  // useEffect(() => {
  //   // if (userId) {
  //   getHandoverEmp()
  //     .then((response) => response.data)
  //     .then((res) => {
  //       if (res.statusCode === 200) {
  //         setEmpData(res?.result);
  //       }
  //     })
  //     .catch((error) => console.log(error));
  //   // }
  // }, []);

  const handlePasscodeClose = () => {
    setPasscodeModal(false);
    setPendingAcceptShift(null);
  };
  return (
    <>
      <Modal
        open={complaintModalOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          {" "}
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box
              sx={ModalStyle}
              className="w-[95%] max-h-[95vh] overflow-y-auto rounded-xl shadow-lg"
            >
              <div className="flex justify-between items-center pb-2">
                <h1 className="font-bold text-[16px] text-gray-800 tracking-wide">
                  ISBAR Handover
                </h1>
                <div
                  className="flex gap-5 items-center
              "
                >
                  <ViewIconISBAR
                    title={"ISBAR Handover List"}
                    onClick={() => {
                      setHandoverSummaryListingModal(true);
                    }}
                  />
                  <CloseModalIcon
                    type="button"
                    className="closeButton"
                    onClick={() => {
                      setComplaintModalOpen(false);
                      setSelectedRow(null);
                      reset(defaultValues);
                    }}
                  />
                </div>
              </div>

              <CommonDivider color="E0E0E0" />

              <div className="mt-1 space-y-1">
                <div className="px-4 py-3 bg-gray-200 border border-gray-200 rounded-lg">
                  <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-2 text-sm">
                    <div className="grid grid-cols-[135px_20px_1fr]">
                      <div className="font-semibold"> Patient Name</div>
                      <div className="text-center">:</div>
                      <div>{displayInfo?.["Patient Name"]}</div>
                    </div>

                    <div className="grid grid-cols-[100px_20px_1fr]">
                      <div className="font-semibold">MR No</div>
                      <div className="text-center">:</div>
                      <div>{displayInfo?.MRNo}</div>
                    </div>

                    <div className="grid grid-cols-[80px_20px_1fr]">
                      <div className="font-semibold">Age</div>
                      <div className="text-center">:</div>
                      <div>{displayInfo?.AgeYear}</div>
                    </div>

                    <div className="grid grid-cols-[130px_20px_1fr]">
                      <div className="font-semibold">Admitting Doctor</div>
                      <div className="text-center">:</div>
                      <div>{displayInfo?.DoctorName}</div>
                    </div>

                    <div className="grid grid-cols-[135px_20px_1fr]">
                      <div className="font-semibold">Bed No</div>
                      <div className="text-center">:</div>
                      <div>{displayInfo?.["Bed No"]}</div>
                    </div>
                  </div>
                </div>

                <div className="divide-y divide-gray-100 border border-gray-200 rounded-t-lg overflow-hidden">
                  <div className="grid grid-cols-4 gap-3 px-1 bg-gray-200 py-3 border border-gray-200">
                    <div className="text-xs flex items-center font-semibold text-gray-700 uppercase tracking-wider mx-4  border-gray-300">
                      Category
                    </div>

                    <div className="text-xs gap-2 flex items-center justify-center font-semibold text-gray-700 uppercase tracking-wider text-center  border-gray-300">
                      Morning{" "}
                      {(!morningData || morningData?.handOverBy == null) &&
                        !selectedRow && (
                          <Tooltip title="Retrieve Details">
                            <span>
                              {" "}
                              <RiDownload2Fill
                                className="h-6 w-6"
                                onClick={() => {
                                  fetchAndPatchColumnMorning("morning");
                                }}
                              />
                            </span>
                          </Tooltip>
                        )}
                    </div>

                    <div className="text-xs gap-2 flex items-center justify-center font-semibold text-gray-700 uppercase tracking-wider text-center border-gray-300 ">
                      Evening
                      {(!eveningData || eveningData?.handOverBy == null) &&
                        !selectedRow && (
                          <Tooltip title="Retrieve Details">
                            <span>
                              <RiDownload2Fill
                                className="h-6 w-6"
                                onClick={() => {
                                  fetchAndPatchColumn("evening");
                                }}
                              />
                            </span>
                          </Tooltip>
                        )}
                    </div>

                    <div className="text-xs gap-2 flex items-center justify-center font-semibold text-gray-700 uppercase tracking-wider text-center">
                      Night
                      {(!nightData || nightData?.handOverBy == null) &&
                        !selectedRow && (
                          <Tooltip title="Retrieve Details">
                            <span>
                              <RiDownload2Fill
                                className="h-6 w-6"
                                onClick={() => {
                                  fetchAndPatchColumn("night");
                                }}
                              />
                            </span>
                          </Tooltip>
                        )}
                    </div>
                  </div>

                  {handoverSummaryData?.map((obj) =>
                    obj?.id !== 5 ? (
                      <div
                        key={obj?.id}
                        className="grid grid-cols-4 gap-0 items-stretch"
                      >
                        <div className="border-r border-gray-200 px-3 py-2 flex items-center">
                          <span className="text-sm font-medium text-gray-700">
                            {obj?.text}
                          </span>
                        </div>

                        <div className="border-r border-gray-200 px-3 py-2 ">
                          <InputArea
                            control={control}
                            label={obj?.text}
                            disabled={selectedRow !== null}
                            name={`${obj?.text}morning${obj?.id}`}
                          />
                        </div>

                        <div className="border-r border-gray-200 px-3 py-2 bg-gray-200">
                          <InputArea
                            control={control}
                            label={obj?.text}
                            disabled={selectedRow !== null}
                            name={`${obj?.text}evening${obj?.id}`}
                          />
                        </div>

                        <div className="px-3 py-2 bg-gray-300">
                          <InputArea
                            control={control}
                            disabled={selectedRow !== null}
                            label={obj?.text}
                            name={`${obj?.text}night${obj?.id}`}
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        key={obj.id}
                        className="grid grid-cols-4 gap-0 items-stretch"
                      >
                        <div className="border-r border-gray-200 p-3 flex items-center">
                          <span className="text-sm font-medium text-gray-700">
                            {obj.text}
                          </span>
                        </div>

                        {/* Morning */}
                        <div className="border-r border-gray-200 px-3 py-1 ">
                          <div className="grid grid-cols-2">
                            <CheckBoxField
                              name={`lineM${obj?.id}`}
                              control={control}
                              label={"Lines"}
                              disabled={selectedRow !== null}
                            />
                            <CheckBoxField
                              name={`drainsM${obj?.id}`}
                              control={control}
                              label={"Drains"}
                              disabled={selectedRow !== null}
                            />
                            <CheckBoxField
                              name={`isolationM${obj?.id}`}
                              control={control}
                              label={"Isolation"}
                              disabled={selectedRow !== null}
                            />
                            <CheckBoxField
                              name={`fallRiskM${obj?.id}`}
                              control={control}
                              label={"Fall Risk"}
                              disabled={selectedRow !== null}
                            />
                          </div>

                          <InputField
                            label="Remark"
                            control={control}
                            disabled={selectedRow !== null}
                            name={`remarkM`}
                          />
                        </div>

                        {/* Evening */}
                        <div className="border-r border-gray-200 px-3 py-1 bg-gray-200">
                          <div className="grid grid-cols-2">
                            <CheckBoxField
                              name={`lineE${obj?.id}`}
                              control={control}
                              label={"Lines"}
                              disabled={selectedRow !== null}
                            />
                            <CheckBoxField
                              name={`drainsE${obj?.id}`}
                              control={control}
                              label={"Drains"}
                              disabled={selectedRow !== null}
                            />
                            <CheckBoxField
                              name={`isolationE${obj?.id}`}
                              control={control}
                              label={"Isolation"}
                              disabled={selectedRow !== null}
                            />
                            <CheckBoxField
                              name={`fallRiskE${obj?.id}`}
                              control={control}
                              label={"Fall Risk"}
                              disabled={selectedRow !== null}
                            />
                          </div>

                          <InputField
                            label="Remark"
                            control={control}
                            disabled={selectedRow !== null}
                            name={`remarkE`}
                          />
                        </div>

                        {/* Night */}
                        <div className="px-3 py-1 bg-gray-300">
                          <div className="grid grid-cols-2">
                            <CheckBoxField
                              name={`lineN${obj?.id}`}
                              control={control}
                              label={"Lines"}
                              disabled={selectedRow !== null}
                            />
                            <CheckBoxField
                              name={`drainsN${obj?.id}`}
                              control={control}
                              label={"Drains"}
                              disabled={selectedRow !== null}
                            />
                            <CheckBoxField
                              name={`isolationN${obj?.id}`}
                              control={control}
                              label={"Isolation"}
                              disabled={selectedRow !== null}
                            />
                            <CheckBoxField
                              name={`fallRiskN${obj?.id}`}
                              control={control}
                              label={"Fall Risk"}
                              disabled={selectedRow !== null}
                            />
                          </div>

                          <InputField
                            label="Remark"
                            control={control}
                            name={`remarkN`}
                            disabled={selectedRow !== null}
                          />
                        </div>
                      </div>
                    ),
                  )}
                </div>
              </div>

              <div className=" text-sm rounded-b-xl   border-gray-200 text-gray-600 overflow-visible w-full">
                <div className="grid grid-cols-4 gap-0  border-gray-200">
                  <div className="flex justify-between">
                    <div className="font-semibold text-sm flex items-center pl-3">
                      Handover By
                    </div>
                    <div className="items-center flex">:</div>
                  </div>
                  <div className="px-4 py-3 text-start border-r border-gray-200 ">
                    {morningData?.handOverBy || "-"}
                  </div>

                  <div className="px-4 py-3 text-start border-r border-gray-200 bg-gray-200">
                    {eveningData?.handOverBy || "-"}
                  </div>

                  <div className="px-4 py-3 text-start bg-gray-300">
                    {nightData?.handOverBy || "-"}
                  </div>
                </div>

                {/* Handover To / Taken By */}
                <div className="grid grid-cols-4 gap-0 ">
                  <div className="flex justify-between">
                    <div className="font-semibold text-sm flex items-center pl-3">
                      Handover To / Taken By
                    </div>
                    <div className="items-center flex">:</div>
                  </div>
                  <div className="px-4 py-3 border-r border-gray-200 ">
                    {morningData?.handOverBy ? (
                      <div className="flex items-center justify-between w-full">
                        <p className="py-1">
                          {morningData?.handOverTakenBy ||
                            morningData?.handoverToName ||
                            "-"}
                        </p>

                        {
                          !morningData?.accepted && !selectedRow && (
                            // morningData?.handoverToId === getUserInfo?.userId && (
                            <button
                              type="button"
                              onClick={() => {
                                setPendingAcceptShift({
                                  shift: "morning",
                                  shiftKey: "M",
                                });
                                setPasscodeModal(true);
                              }}
                              // onClick={() => handleAccept("morning", "M")}
                              className="px-4 py-1 rounded-md border border-customBlue text-customBlue hover:bg-customBlue hover:text-white"
                            >
                              Accept
                            </button>
                          )
                          // )
                        }
                      </div>
                    ) : !selectedRow ? (
                      <div className="w-full flex gap-1">
                        <SearchDropdown
                          handleInputChange={(e) => {
                            const tempCheckChar =
                              e !== null
                                ? UseCheckConsecutiveCharacters(e)
                                : true;
                            if (e !== "" && tempCheckChar) {
                              getHandoverEmp({ searchString: e })
                                .then((response) => {
                                  setEmpData(response.data.result);
                                })
                                .catch((error) => {
                                  console.log(error);
                                });
                            } else {
                              setEmpData([]);
                            }
                          }}
                          onChange={() => {}}
                          dataArray={empData}
                          control={control}
                          name="assignStaff"
                          placeholder="Handover To "
                          error={errors.applicableRoles}
                          isClearable
                          isSearchable
                          menuPlacement="top"
                          searchIcon
                        />

                        <CommonButton
                          onClick={() => setSelectedShift("morning")}
                          label="Save"
                          type="submit"
                          className="px-6 py-2 bg-green-700 text-white"
                        />
                      </div>
                    ) : (
                      "-"
                    )}
                  </div>

                  <div className="px-4 py-3 border-r border-gray-200 bg-gray-200">
                    {eveningData?.handOverBy ? (
                      <div className="flex items-center justify-between w-full">
                        <p className="py-1">
                          {eveningData?.handOverTakenBy ||
                            eveningData?.handoverToName ||
                            "-"}
                        </p>

                        {
                          !eveningData?.accepted && !selectedRow && (
                            // eveningData?.handoverToId === getUserInfo?.userId && (
                            <button
                              type="button"
                              onClick={() => {
                                setPendingAcceptShift({
                                  shift: "evening",
                                  shiftKey: "E",
                                });
                                setPasscodeModal(true);
                              }}
                              // onClick={() => handleAccept("evening", "E")}
                              className="px-4 py-1 rounded-md border border-customBlue text-customBlue hover:bg-customBlue hover:text-white"
                            >
                              Accept
                            </button>
                          )
                          // )
                        }
                      </div>
                    ) : !selectedRow ? (
                      <div className="w-full flex gap-1">
                        <SearchDropdown
                          // handleInputChange={(e) => {}}
                          handleInputChange={(e) => {
                            const tempCheckChar =
                              e !== null
                                ? UseCheckConsecutiveCharacters(e)
                                : true;
                            if (e !== "" && tempCheckChar) {
                              getHandoverEmp({ searchString: e })
                                .then((response) => {
                                  setEmpData(response.data.result);
                                })
                                .catch((error) => {
                                  console.log(error);
                                });
                            } else {
                              setEmpData([]);
                            }
                          }}
                          onChange={() => {}}
                          dataArray={empData}
                          // dataArray={employeeNameOptions}
                          control={control}
                          name="assignStaffEvening"
                          placeholder="Handover To"
                          error={errors?.assignStaffEvening}
                          isClearable
                          isSearchable
                          menuPlacement="top"
                          searchIcon
                        />

                        <CommonButton
                          onClick={() => setSelectedShift("evening")}
                          label="Save"
                          type="submit"
                          className="px-6 py-2 bg-green-700 text-white"
                        />
                      </div>
                    ) : (
                      "-"
                    )}
                  </div>

                  <div className="px-4 py-3 bg-gray-300 rounded-br-xl">
                    {nightData?.handOverBy ? (
                      <div className="flex items-center justify-between w-full">
                        <p className="py-1">
                          {nightData?.handOverTakenBy ||
                            nightData?.handoverToName ||
                            "-"}
                        </p>

                        {
                          !nightData?.accepted && !selectedRow && (
                            // nightData?.handoverToId === getUserInfo?.userId && (
                            <button
                              type="button"
                              onClick={() => {
                                setPendingAcceptShift({
                                  shift: "night",
                                  shiftKey: "N",
                                });
                                setPasscodeModal(true);
                              }}
                              // onClick={() => handleAccept("night", "N")}
                              className="px-4 py-1 rounded-md border border-customBlue text-customBlue hover:bg-customBlue hover:text-white"
                            >
                              Accept
                            </button>
                          )
                          // )
                        }
                      </div>
                    ) : !selectedRow ? (
                      <div className="w-full flex gap-1 ">
                        <SearchDropdown
                          // handleInputChange={(e) => {}}
                          handleInputChange={(e) => {
                            const tempCheckChar =
                              e !== null
                                ? UseCheckConsecutiveCharacters(e)
                                : true;
                            if (e !== "" && tempCheckChar) {
                              getHandoverEmp({ searchString: e })
                                .then((response) => {
                                  setEmpData(response.data.result);
                                })
                                .catch((error) => {
                                  console.log(error);
                                });
                            } else {
                              setEmpData([]);
                            }
                          }}
                          onChange={() => {}}
                          // dataArray={employeeNameOptions}
                          dataArray={empData}
                          control={control}
                          name="assignStaffNight"
                          placeholder="Handover To"
                          error={errors?.assignStaffNight}
                          isClearable
                          isSearchable
                          menuPlacement="top"
                          searchIcon
                        />

                        <CommonButton
                          onClick={() => setSelectedShift("night")}
                          label="Save"
                          type="submit"
                          className="px-6 py-2 bg-green-700 text-white"
                        />
                      </div>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </div>
            </Box>

            {openBackDrop && <CommonBackDrop openBackdrop={openBackDrop} />}
            {handoverSummaryListingModal && (
              <ISBARHandoverListingModal
                handoverSummaryListingModal={handoverSummaryListingModal}
                setHandoverSummaryListingModal={setHandoverSummaryListingModal}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
                admissionId={displayInfo?.AdmissionId}
              />
            )}
          </form>{" "}
          {passcodeModal && (
            <ISBARHandoverPasscodeModal
              open={passcodeModal}
              onClose={handlePasscodeClose}
              onSubmit={(passcode) =>
                handleAccept(
                  pendingAcceptShift?.shift,
                  pendingAcceptShift?.shiftKey,
                  passcode,
                )
              }
            />
          )}
        </div>
      </Modal>

      <ConfirmationModal
        confirmationOpen={openPostModal}
        confirmationHandleClose={() => setOpenPostModal(false)}
        confirmationLabel="Confirmation"
        confirmationMsg={`Are you sure you want to save this record?`}
        confirmationSubmitFunc={() => {
          handleSaveRecord();
        }}
        confirmationButtonMsg="Save"
      />
    </>
  );
};

export default ISBARHandover;